import React from "react";
import { Modal, Button } from "react-bootstrap";

export const ElencoErroriRicetta = (opResult, options = {}) => {
    if (!opResult) return null;

    const {
        show = true,
        title = "Errori",
        size = "lg",
        backdrop = "static",
        centered = true,
        keyboard = false,
        onClose = null, // () => ...
    } = options;

    const rows = Array.isArray(opResult?.ui?.errorRows) ? opResult.ui.errorRows : [];
    const detailsJson = opResult?.ui?.detailsJson ?? opResult?.data ?? null;

    // Se non ho nulla da mostrare, non apro la modale
    if (!rows.length && !detailsJson) return null;

    const handleHide = () => {
        if (typeof onClose === "function") onClose();
    };

    return (
        <Modal
            show={show}
            size={size}
            onHide={handleHide}
            backdrop={backdrop}
            aria-labelledby="contained-modal-title-vcenter"
            centered={centered}
            keyboard={keyboard}
        >
            <Modal.Header closeButton>
                <Modal.Title id="contained-modal-title-vcenter">
                    {title}
                </Modal.Title>
            </Modal.Header>

            <Modal.Body>
                {/* Alert sintetico (opzionale) */}
                {opResult?.ui?.userMessage && (
                    <div className="alert alert-danger">
                        {opResult.ui.userMessage}
                    </div>
                )}

                {/* Tabella errori */}
                {rows.length > 0 && (
                    <div className="table-responsive">
                        <table className="table table-sm table-bordered mb-0">
                            <thead>
                                <tr>
                                    <th style={{ width: 120 }}>Progressivo</th>
                                    <th>Messaggio</th>
                                </tr>
                            </thead>
                            <tbody>
                                {rows.map((r, idx) => (
                                    <tr key={idx}>
                                        <td>{r.progressivo || ""}</td>
                                        <td>{r.messaggio || ""}</td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                )}

                {detailsJson && (
                    <details className="mt-3">
                        <summary className="text-muted">Dettagli Tecnici</summary>
                        <pre className="mt-2" style={{ fontSize: 12 }}>
                            {JSON.stringify(detailsJson, null, 2)}
                        </pre>
                    </details>
                )}
            </Modal.Body>

            <Modal.Footer>
                <div className="text-end">
                    <Button variant="primary" onClick={handleHide}>
                        Chiudi
                    </Button>
                </div>
            </Modal.Footer>
        </Modal>
    );
};
